import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Description, Title } from '../../components/common/title/index';
import { FormGroup, Input, Label } from 'reactstrap';
import InputBox from '../../components/common/input/index';
import Image from '../../components/common/image/index';
import { X } from 'react-feather';
import { useNavigate } from 'react-router-dom';

// Firebase
import { auth } from '../../firebase/firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';

const Check = '/assets/images/login/check.png';


function Login(props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setErrors] = useState('');
  const [errorCreate, setErrorsCreate] = useState('');
  const [success, setSuccess] = useState(false);
  const [successContext, setSuccessContext] = useState('login');
  const [tabIndex, setTabIndex] = useState(0);

  const navigate = useNavigate();

  // createAccountFirebase used to live here — a second, lesser copy of the
  // signup form on /register. It collected no password confirmation, offered
  // only Educator and Parent, and wrote no `intendedRole`, so anyone who used
  // it landed on "We're missing a detail" after verifying their email and
  // then hit "email already exists" when they tried the real form. One
  // signup form now, on /register.

  const loginWithFirebase = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password.trim())
      .then(() => { setSuccessContext('login'); setSuccess(true); })
      .catch((e) => setErrors(e.message));
  };

  return (
    <div className="login-register-outer">
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Login</Tab>
          <Tab>Register</Tab>
        </TabList>

        <TabPanel>
          <div className="tabfirst-block">
            <Title Class="tab-title" Name="Smart Board Learning" />
            <Description Class="tab-dec" Name="Please login to continue" />
            <div className="form-wrapper">
              <FormGroup>
                <InputBox
                  Type="text"
                  Name="email"
                  PlaceHolder="Email Address"
                  ChangeValue={setEmail}
                />
              </FormGroup>
              <FormGroup>
                <InputBox
                  Type="password"
                  Name="password"
                  PlaceHolder="Password"
                  ChangeValue={setPassword}
                />
                <span className="errorFirebase">{error}</span>
              </FormGroup>

              <FormGroup className="checkbox-password form-check d-flex align-items-center" check>
                <Input type="checkbox" id="rememberMe" className="form-check-input" />
                <Label check htmlFor="rememberMe" className="form-check-label mb-0">
                  Remember Me
                </Label>
                <button type="button" className="forget-password ms-auto">Forget Password</button>
              </FormGroup>
              <button type="button" className="login-btn gradient-color" onClick={loginWithFirebase}>Login</button>
              <p className="switch-to-register">
                Not a member yet?{' '}
                <button type="button" className="link-btn" onClick={() => setTabIndex(1)}>
                  Sign Up
                </button>
              </p>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tabfirst-block">
            <Title Class="tab-title" Name="Welcome to Smart Board Learning" />
            <Description Class="tab-dec" Name="Create your account to get started" />
            <div className="form-wrapper">
              <p className="register-handoff">
                Signing up takes a minute. You'll pick whether you're an
                educator, parent, or school, choose your state and grade, and
                confirm your password — then land straight in your dashboard
                with five topics per subject unlocked, free.
              </p>
              <button
                type="button"
                className="login-btn gradient-color"
                onClick={() => {
                  if (props.Click) props.Click();
                  navigate('/register');
                }}
              >
                Create my account
              </button>
            </div>
          </div>
        </TabPanel>
      </Tabs>
      <div className="login-close gradient-color" onClick={props.Click}>
        <X />
      </div>
      {success &&
        <div className="login-success-popup">
          <div className="login-success-box">
            <div className="login-check-images">
              <Image Path={Check} />
            </div>
            <div className="login-success-content">
              <Title Class="login-success-title" Name="Success" />
              <Description
                Class="login-success-dec"
                Name={
                  successContext === 'register'
                    ? "We sent a verification link to your email. Click it to unlock full access to your dashboard."
                    : "Thank you for visiting our site."
                }
              />
              <button
                type="button"
                className="login-success-btn"
                onClick={() => window.location.assign('/')}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      }

      <style>{`
        .login-register-outer {
          background: #fff;
          border-radius: 16px;
          padding: 32px 30px 26px;
          width: 420px;
          max-width: 92vw;
          max-height: 88vh;
          overflow-y: auto;
          position: relative;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
        }
        .login-register-outer .react-tabs__tab-list {
          display: flex;
          gap: 8px;
          list-style: none;
          padding: 0;
          margin: 0 0 20px;
          border-bottom: 1px solid #eee;
        }
        .login-register-outer .react-tabs__tab {
          flex: 1;
          text-align: center;
          padding: 10px 0;
          cursor: pointer;
          font-weight: 700;
          color: #999;
          border-bottom: 2px solid transparent;
        }
        .login-register-outer .react-tabs__tab--selected {
          color: #7f00ff;
          border-bottom: 2px solid #7f00ff;
        }
        .tab-title {
          margin: 0 0 4px;
          font-size: 20px;
          font-weight: 800;
          color: #111;
        }
        .tab-dec {
          margin: 0 0 18px;
          font-size: 13px;
          color: #777;
        }
        .form-wrapper .form-control,
        .form-wrapper input:not([type="checkbox"]) {
          width: 100%;
          padding: 11px 14px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 14px;
          margin-bottom: 12px;
          box-sizing: border-box;
        }
        .checkbox-password {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          gap: 8px;
          padding-left: 0;
          margin-bottom: 16px;
        }
        .checkbox-password .form-check-input[type="checkbox"] {
          width: 15px;
          height: 15px;
          min-width: 15px;
          flex: 0 0 15px;
          margin: 0;
          padding: 0;
          border-radius: 3px;
          box-sizing: border-box;
          cursor: pointer;
          accent-color: #7f00ff;
        }
        .checkbox-password .form-check-label {
          font-size: 13px;
          line-height: 1.2;
          color: #555;
          white-space: nowrap;
          cursor: pointer;
          margin: 0;
        }
        .register-handoff {
          font-size: clamp(0.85rem, 2vw, 0.95rem);
          line-height: 1.6;
          color: #444;
          margin-bottom: 18px;
        }
        .role-label {
          display: block;
          font-size: 13px;
          font-weight: 600;
          color: #555;
          margin-bottom: 6px;
        }
        .form-row-2 {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }
        .state-select {
          background: #fff;
        }
        .login-btn {
          width: 100%;
          border: none;
          border-radius: 8px;
          padding: 12px;
          color: #fff;
          font-weight: 700;
          cursor: pointer;
          margin-top: 4px;
        }
        .login-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .forget-password {
          background: none;
          border: none;
          padding: 0;
          color: #7f00ff;
          font-size: 13px;
          line-height: 1.2;
          white-space: nowrap;
          cursor: pointer;
        }
        .login-close {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          cursor: pointer;
        }
        .login-success-popup {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1200;
        }
        .login-success-box {
          background: #fff;
          border-radius: 14px;
          padding: 30px;
          text-align: center;
          width: 320px;
          max-width: 90vw;
        }
        .login-success-btn {
          margin-top: 14px;
          border: none;
          border-radius: 8px;
          padding: 10px 24px;
          background: #7f00ff;
          color: #fff;
          font-weight: 700;
          cursor: pointer;
        }
        .errorFirebase{
          color: red;
          margin-top: -6px;
          margin-bottom: 10px;
          display: block;
          font-size: 13px;
        }
        .switch-to-register {
          margin-top: 14px;
          text-align: center;
          font-size: 14px;
          color: #333;
        }
        .link-btn {
          background: none;
          border: none;
          padding: 0;
          color: #7f00ff;
          font-weight: 700;
          cursor: pointer;
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}

export default Login;
